import { publicInstance } from "../axios";

export const getSettings = async() => {
    return await publicInstance
        .get("/home/settings")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getSeoAnalytics = async() => {
    return await publicInstance
        .get("/home/get-seo-analytics")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getSeoContent = async(id, catId = 0) => {
    return await publicInstance
        .get("/home/get-seo-content?id=" + id + "&item=" + catId)
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHomePageBanners = async() => {
    return await publicInstance
        .get("/home/slider")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};

export const getHomePageCategories = async() => {
    return await publicInstance
        .get("get-category")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHeaderMenu = async() => {
    return await publicInstance
        .get("get-header-menu")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getMenuBanner = async() => {
    return await publicInstance
        .get("get-menu-banner")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getFooterMenuService = async() => {
    return await publicInstance
        .get("get-footer-menu")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHomePageDeals = async() => {
    return await publicInstance
        .get("deal-products")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHomePageOffers = async(position = null) => {
    return await publicInstance
        .get(position ? `home-promotion?position=${position}` : "home-promotion")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHomePageSeo = async(position = null) => {
    return await publicInstance
        .get("get-home-page-seo")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHomePageNewBlock = async() => {
    return await publicInstance
        .get("home-new-block")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHomePageCampaignBlock = async() => {
    return await publicInstance
        .get("home-campaign-block")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getOfferList = async(itemId) => {
    const submitData = {
        itemId: itemId,
    };

    return await publicInstance
        .post("offer-listing", submitData)
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return "API error";
        });
};
export const getCampaignList = async(itemId) => {
    const submitData = {
        itemId: itemId,
    };

    return await publicInstance
        .post("campaign-offer", submitData)
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return "API error";
        });
};
export const getHomePageTopSellingProducts = async() => {
    return await publicInstance
        .get("top-selling-products")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHomePageRecommendedProducts = async() => {
    return await publicInstance
        .get("recommended-products")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getOurFeatures = async() => {
    return await publicInstance
        .get("our-features")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getFaqData = async() => {
    return await publicInstance
        .get("faq")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getCmsData = async(id) => {
    return await publicInstance
        .get("cms?id=" + id)
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const checkCartProceed = async() => {
    
    return await publicInstance
        .get("cart-proceed")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHomePageAds = async(
    position = "",
    category = "",
    page = ""
) => {
    return await publicInstance
        .get(`ads?position=${position}&category=${category}&page=${page}`)
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getTrendingBrands = async() => {
    return await publicInstance
        .get("brands")
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};
export const getHomePageSuperSaver = async(id, limit, offset) => {
    return await publicInstance
        .get("super-saver?id=" + id + "&limit=" + limit + "&offset=" + offset)
        .then((res) => {
            if (res.data && res.data.status) {
                return res.data.data;
            } else return [];
        })
        .catch((error) => {
            return [];
        });
};